import { escapeHtml } from "../acrotohtml/escapeHtml";
import type { DocTableRow } from "./types";
import { renderDocXItem } from "./renderDocXItem";

export function renderTableRow(row: DocTableRow): string {
  if (row.ClickToAddButton) {
    return `
      <button 
        type="button" 
        class="m-4 ml-auto btn-secondary !px-3 !py-2 btn-primary text-xs"
        data-table-id="${escapeHtml(row.RowId)}"
      >
        + Click to Add Row
      </button>
    `;
  }

  const gridLength = row.GridLength || 1;
  
  // Build grid-template-columns based on GridSpan and GridLength
  const gridColumns = row.docXElements
    .map((element) => {
      const gridSpan = element.GridSpan || 1;
      const widthPercent = (gridSpan / gridLength) * 100;
      return `${widthPercent}%`;
    })
    .join(" ");

  const cellsHtml = row.docXElements
    .map((element) => {
      const itemsHtml = element.docXItems
        .map((item) => renderDocXItem(item))
        .join(" ");
      return `<div class="cell-wrapper border-r last:border-r-0 border-gray-300 px-3 py-2 flex flex-wrap items-center gap-3">${itemsHtml}</div>`;
    })
    .join("");

  return `
    <div 
      class="even:bg-gray-50 border-b border-gray-300 last:border-b-0" 
      data-row-id="${escapeHtml(row.RowId)}"
      style="display:grid;grid-template-columns:${gridColumns};gap:0"
    >
      ${cellsHtml}
    </div>
  `;
}
